import { createCustomElement } from '@angular/elements';
import { Component, Injector, NgModule } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http'; // Import HttpClientModule explicitly
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // Import BrowserAnimationsModule explicitly

// Importing your standalone components to be used as Angular Elements
import { ServiceProviderProfileComponent } from './app/service-provider-profile/service-provider-profile.component';
import { RecruiterProfileComponent } from './app/recruiter-profile/recruiter-profile.component';
import { JobDetailsComponent } from './app/job-details/job-details.component';
import { AddIssueComponent } from './app/add-issue/add-issue.component';
import { CitizenProfileComponent } from './app/citizen-profile/citizen-profile.component';
import { LeaderProfileComponent } from './app/leader-profile/leader-profile.component';
import { IssueCardComponent } from './app/issue-card/issue-card.component';
import { ServicesCardComponent } from './app/services-card/services-card.component';
import { BannerComponent } from './app/banner/banner.component';
import { TabsComponent } from './app/tabs/tabs.component';
import { SingleIssueViewComponent } from './app/single-issue-view/single-issue-view.component';
import { CommentComponent } from './app/comment/comment.component';

@NgModule({
  imports: [
    BrowserModule, // Add BrowserModule here
    HttpClientModule, // Explicitly import HttpClientModule for HTTP services
    BrowserAnimationsModule, // Explicitly import BrowserAnimationsModule for animations
  ],
  providers: [],
})
class AppModule {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    const componentsToRegister = [
      { tag: 'service-provider-profile', component: ServiceProviderProfileComponent },
      { tag: 'recruiter-profile', component: RecruiterProfileComponent },
      { tag: 'job-details', component: JobDetailsComponent },
      { tag: 'add-issue', component: AddIssueComponent },
      { tag: 'add-citizen-profile', component: CitizenProfileComponent },
      { tag: 'leader-profile', component: LeaderProfileComponent },
      { tag: 'citizen-issue', component: IssueCardComponent },
      { tag: 'services-card', component: ServicesCardComponent },
      { tag: 'app-banner', component: BannerComponent},
      { tag: 'app-tabs', component: TabsComponent},
      { tag: 'single-issue-view', component: SingleIssueViewComponent},
      { tag: 'comment-component', component: CommentComponent}
    ];

    // Initialize the global customElementsList if not already present
    if (!(window as any).customElementsList) {
      (window as any).customElementsList = [];
    }

    // Register custom elements and store them in the global list in a single loop
    componentsToRegister.forEach(({ tag, component }) => {
      if (!customElements.get(tag)) {
        const element = createCustomElement(component, { injector: this.injector });
        customElements.define(tag, element);  // Define the custom element
        
        // Push registered component details into the customElementsList
        (window as any).customElementsList.push({ component: tag, componentClass: component });
      }
    });
  }
}
if ((window as any).appRef) {
  (window as any).appRef.destroy();
  (window as any).appRef = null;
}

if (!(window as any).appBootstrapped) {
  (window as any).appBootstrapped = true;

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((ref) => {
      (window as any).appRef = ref; // Store reference for cleanup
    })
    .catch((err) => console.error(err));
}

